export const sharedSourceNames = {
  balls: 'assets_shared_balls.png',
  freeSpin: 'assets_shared_free_spins.png',
  multiplier: 'assets_shared_multiplier.png',
  winBackground: 'assets_shared_win_background.png',
  ticketX1Light: 'assets_shared_tickets_light_x_1.png',
  ticketX3Light: 'assets_shared_tickets_light_x_3.png',
  ticketX5Light: 'assets_shared_tickets_light_x_5.png',
  ticketX1Bow: 'assets_shared_tickets_x_1_bow.png',
  ticketX3Bow: 'assets_shared_tickets_x_3_bow.png',
  ticketX5Bow: 'assets_shared_tickets_x_5_bow.png',
  ticketX1: 'assets_shared_tickets_x_1.png',
  ticketX3: 'assets_shared_tickets_x_3.png',
  ticketX5: 'assets_shared_tickets_x_5.png',
  switchIcon: 'assets_shared_icons_switch_icon.svg',
  autoSpinStopIcon: 'assets_gamePadSrc_auto_spin_icon',
  buttonNoActive: 'assets_shared_popups_button_no_active.png',
  buttonNoNormal: 'assets_shared_popups_button_no_normal.png',
  buttonYesActive: 'assets_shared_popups_button_yes_active.png',
  buttonYesNormal: 'assets_shared_icons_popups_button_yes_normal.png',
  buyBonusPopup: 'assets_shared_icons_popups_buy_bonus_popup.png',
  greenPopupLightSpine: 'animations_shared_green_popup',
  purplePopupLightSpine: 'animations_shared_purple_popup',
  continueButtonActive: 'assets_shared_popups_continue_button_active.png',
  continueButtonNormal: 'assets_shared_popups_continue_button_normal.png',
  congratulationsPopup: 'assets_shared_popups_congratulations_popup.png',
  goldenArrow: 'assets_shared_icons_popups_golden_arrow.png',
  backgroundShadow: 'assets_shared_popups_background_shadow.svg',
  infinityIconBark: 'assets_gamePadSrc_infinity_icon_bark.svg',
  depositIcon: 'assets_gamePadSrc_deposit_icon.svg',
  leaf: 'animations_shared_leaf',
  bonusLeaf: 'assets_shared_popups_bonus_leaf.png'
};

export const controllerSourceNames = {
  controlWhiteCircle: 'assets_shared_icons_control_white_circle.svg',
  soundOffIcon: 'assets_shared_icons_sound_off_icon.svg',
  soundOffIconMobile: 'assets_shared_icons_sound_off_icon_mobile.svg',
  soundOnIcon: 'assets_shared_icons_sound_on_icon.svg',
  historyIcon: 'assets_shared_icons_history_icon.svg',
  historyIconMobile: 'assets_shared_icons_history_icon_mobile.svg',
  historyIconActive: 'assets_shared_icons_history_icon_active.svg',
  infoIcon: 'assets_shared_icons_info_icon.svg',
  infoIconMobile: 'assets_shared_icons_info_icon_mobile.svg',
  infoIconActive: 'assets_shared_icons_info_icon_active.svg',
}

export const webSourceNames = {
  background: 'assets_web_background.jpg',
  shadow: 'assets_web_shadow.png',
  tiki: 'assets_web_tiki.png',
  tikiBack: 'assets_web_tiki_back.png',
  waterfallSpine: 'animations_web_waterfall',
  waterSpine: 'animations_web_water',
  wallSpine: 'animations_web_wall',
  treesSpine: 'animations_web_trees',
  dragonSoulSpine: 'animations_web_dragon_soul',
  dragonSpine: 'animations_web_dragon',
  breakingBallSpine: 'animations_web_breaking_ball',
  particles: 'animations_web_particles',
  fishSpine: 'animations_web_fish',
  bigWinCoinsSpine: 'animations_web_big_win_big_win_coins',
  bigWinWordsSpine: 'animations_web_big_win_big_win_words',
  buyBonusButton: 'assets_web_buy_bonus_button.png',
};

export const mobileSourceNames = {
  background: 'assets_mobile_background.jpg',
  shadow: 'assets_mobile_shadow.png',
  tiki: 'assets_mobile_tiki.png',
  tikiBack: 'assets_mobile_tiki_back.png',
  waterfallSpine: 'animations_mobile_waterfall',
  waterSpine: 'animations_mobile_water',
  wallSpine: 'animations_mobile_wall',
  treesSpine: 'animations_mobile_trees',
  plateSpine: 'animations_mobile_plate',
  dragonSoulSpine: 'animations_mobile_dragon_soul',
  dragonSpine: 'animations_mobile_dragon',
  breakingBallSpine: 'animations_mobile_breaking_ball',
  particles: 'animations_mobile_particles',
  fishSpine: 'animations_mobile_fish',
  bigWinCoinsSpine: 'animations_mobile_big_win_big_win_coins',
  bigWinWordsSpine: 'animations_mobile_big_win_big_win_words',
  shadowBottom: 'assets_mobile_shadow_bottom.svg',
};
